import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetLicenseeReturnFromComplianceInvestigationFetchUrl,
  GetLicenseeReturnFromSiteVisitFetchUrl,
  ILicenseeReturn,
} from "../../api/ILicenseeReturns";
import { GetLicenseeReturnPageUrl } from "../../leap-pages/routeFactory";
import { Grid } from "../Grid";
import { getIconForType } from "../icons/LeapIcons";
import { LicenseeReturnGridProps } from "./LicenseeReturnGridProps";

const LicenseeReturnsGrid = ({
  relatedRecordType,
  relatedrecordId,
  licenceProfile,
}: LicenseeReturnGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      switch (relatedRecordType) {
        case "CI":
          return GetLicenseeReturnFromComplianceInvestigationFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
        case "Site Visit":
        default:
          return GetLicenseeReturnFromSiteVisitFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
      }
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(relatedrecordId);

  const tableColumnsBig: Column<Record<string, ILicenseeReturn>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType("Licensee Return")}</span>
            </td>
            <td>
              <Link
                to={GetLicenseeReturnPageUrl(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenseereturnid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Date",
      accessor: "datereceived",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Title",
      accessor: "subject",
      Filter: false,
    },
    {
      Header: "Document Type",
      accessor: "doctype",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Document SubType",
      accessor: "docsubtype",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Decision",
      accessor: "decision",
      Filter: false,
      filter: "includes",
    },
  ];

  const tableColumnsSmall: Column<Record<string, ILicenseeReturn>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType("Licensee Return")}</span>
            </td>
            <td>
              <Link
                to={GetLicenseeReturnPageUrl(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenseereturnid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Title",
      accessor: "subject",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { LicenseeReturnsGrid };
